import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'

import authReducer from './slices/authSlice'
import filterReducer from './slices/filterSlice'
import listingReducer from './slices/listingSlice'
import reviewReducer from './slices/reviewSlice'
import likesReducer from './slices/likeSlice'
import cartReducer from './slices/cartSlice'
import addressReducer from './slices/addressSlice'
import locationReducer from './slices/locationSlice'
import chatReducer from './slices/chatSlice'
import currencyReducer from './slices/currencySlice'
import shippingReducer from './slices/deliverySlice'
import paymentReducer from './slices/paymentSlice'
import productReducer from './slices/productSlice'
import orderReducer from './slices/orderSlice'
import algoliaOrderReducer from './slices/algoliaOrderSlice'
import userReducer from './slices/userSlice'
import checkoutReducer from './slices/checkoutSlice'
import offerReducer from './slices/offerSlice'
import requestReducer from './slices/requestSlice'
import fulfillmentGroupReducer from './slices/fulfillmentGroupSlice'
import launchConfigReducer from './slices/launchConfigSlice'

import {
  enhancedAuthApi,
  enhancedProductApi,
  enhancedListingApi,
  enhancedReviewApi,
  enhancedProfileApi,
  enhancedAddressApi,
  enhancedCartApi,
  enhancedClosetApi,
  userApi,
  offerApi,
  requestApi
} from './apis'

import { messageApi } from './apis/endpoints/messageApi'
import { enhancedDeliveryApi } from './apis/endpoints/deliveryApi'
import { paymentApi } from './apis/endpoints/paymentApi'
import { enhancedOrderApi } from './apis/endpoints/orderApi'
import { fulfillmentGroupApi } from './apis/endpoints/fulfillmentGroupApi'
import { orderItemApi } from './apis/endpoints/orderItemApi'
import { enhancedLaunchConfigApi } from './apis/endpoints/launchConfigApi'
import { enhancedHomeFeatureApi } from './apis/endpoints/homeFeatureApi'
import { enhancedProductPhotoApi } from './apis/endpoints/productPhotoApi'
import { enhancedMapDropApi } from './apis/endpoints/mapDropApi'
import { enhancedVtoApi } from './apis/endpoints/vtoApi'
import { enhancedLicensingApi } from './apis/endpoints/licensingApi'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    filter: filterReducer,
    listing: listingReducer,
    review: reviewReducer,
    likes: likesReducer,
    cart: cartReducer,
    address: addressReducer,
    location: locationReducer,
    chat: chatReducer,
    currency: currencyReducer,
    shipping: shippingReducer,
    payment: paymentReducer,
    product: productReducer,
    order: orderReducer,
    algoliaOrders: algoliaOrderReducer,
    user: userReducer,
    checkout: checkoutReducer,
    offer: offerReducer,
    request: requestReducer,
    fulfillmentGroup: fulfillmentGroupReducer,
    launchConfig: launchConfigReducer,
    [enhancedAuthApi.reducerPath]: enhancedAuthApi.reducer,
    [enhancedProductApi.reducerPath]: enhancedProductApi.reducer,
    [enhancedListingApi.reducerPath]: enhancedListingApi.reducer,
    [enhancedReviewApi.reducerPath]: enhancedReviewApi.reducer,
    [enhancedProfileApi.reducerPath]: enhancedProfileApi.reducer,
    [enhancedAddressApi.reducerPath]: enhancedAddressApi.reducer,
    [enhancedCartApi.reducerPath]: enhancedCartApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [enhancedDeliveryApi.reducerPath]: enhancedDeliveryApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [enhancedOrderApi.reducerPath]: enhancedOrderApi.reducer,
    [offerApi.reducerPath]: offerApi.reducer,
    [requestApi.reducerPath]: requestApi.reducer,
    [fulfillmentGroupApi.reducerPath]: fulfillmentGroupApi.reducer,
    [orderItemApi.reducerPath]: orderItemApi.reducer,
    [enhancedLaunchConfigApi.reducerPath]: enhancedLaunchConfigApi.reducer,
    [enhancedClosetApi.reducerPath]: enhancedClosetApi.reducer,
    [enhancedHomeFeatureApi.reducerPath]: enhancedHomeFeatureApi.reducer,
    [enhancedProductPhotoApi.reducerPath]: enhancedProductPhotoApi.reducer,
    [enhancedMapDropApi.reducerPath]: enhancedMapDropApi.reducer,
    [enhancedVtoApi.reducerPath]: enhancedVtoApi.reducer,
    [enhancedLicensingApi.reducerPath]: enhancedLicensingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(
      enhancedAuthApi.middleware,
      enhancedProductApi.middleware,
      enhancedListingApi.middleware,
      enhancedReviewApi.middleware,
      enhancedProfileApi.middleware,
      enhancedAddressApi.middleware,
      enhancedCartApi.middleware,
      messageApi.middleware,
      userApi.middleware,
      enhancedDeliveryApi.middleware,
      paymentApi.middleware,
      enhancedOrderApi.middleware,
      offerApi.middleware,
      requestApi.middleware,
      fulfillmentGroupApi.middleware,
      orderItemApi.middleware,
      enhancedLaunchConfigApi.middleware,
      enhancedClosetApi.middleware,
      enhancedHomeFeatureApi.middleware,
      enhancedProductPhotoApi.middleware,
      enhancedMapDropApi.middleware,
      enhancedVtoApi.middleware,
      enhancedLicensingApi.middleware
    ),
  devTools: process.env.NODE_ENV !== 'production',
})

setupListeners(store.dispatch)

if (process.env.NODE_ENV !== 'production') {
  window.store = store;
}

export default store